module.exports = __webpack_public_path__ + "img/maridaje_red.02808c3c.png";